<div class="header-container">
	<div class="logo-container">
		<!-- <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-outline" status="control"></nb-icon>
    </a> -->

		<a class="logo" href="#" (click)="navigateHome()">
			<img
				height="44px"
				src="/assets/images/header_logo.png"
				alt="company logo"
			/>
			<span class="fw-bold ms-2">{{ 'APP.NAME' | translate }}</span>
		</a>
	</div>
</div>

<div class="header-container">
	<nb-actions size="small" class="cursor-pointer">
		<nb-action class="text-white fw-normal font-size-14">
			{{ user?.PartitaIvaUdD + ' - ' + user?.RagSocialeUdD }}
			<nb-icon
				(click)="onOpenDialogSelectUdd()"
				*nbIsGranted="['edit', 'user-data-header']"
				class="mb-1 ms-1"
				icon="chevron-down-outline"
				status="control"
			></nb-icon>
		</nb-action>

		<nb-action
			class="control-item"
			[title]="'UPLOADS.TITLE' | translate"
			[icon]="{ icon: 'upload-outline', status: 'control' }"
			badgePosition="top right"
			badgeStatus="warning"
			[badgeDot]="isBadge"
			(click)="navigateUploads()"
		></nb-action>

		<nb-action>
			<app-user-action></app-user-action>
		</nb-action>
	</nb-actions>
</div>

<!-- DIALOG CHOOSE UDD SUPERUSER -->
<ng-template #selectUddDialogTemplate>
	<div class="row my-1" [ngStyle]="{'vertical-align': 'middle'}">
		<div class="col-md-11 ps-1">
			<b>{{ 'LOGIN.ALERT.TITLE' | translate }}</b>
		</div>
		<div
			class="col-md-1"
			[ngStyle]="{'text-align': 'right', 'font-size': '2.5rem'}"
		>
			<nb-icon
				icon="close-outline"
				(click)="dialogRef.close()"
				[ngStyle]="{cursor: 'pointer', 'vertical-align': 'top'}"
			></nb-icon>
		</div>
	</div>

	<div class="row alertHighlightSection">
		<div class="col-md-12 my-auto">
			{{ 'LOGIN.ALERT.SUB_TITLE' | translate }}
		</div>
	</div>

	<!-- <form action="" #formSU="ngForm"> -->
	<div class="row mx-5 mt-3 mb-3">
		<div class="form-control-group mt-3" [ngStyle]="{width: '100%'}">
			<div>
				<app-form [form]="superUserForm"></app-form>
			</div>
		</div>
	</div>

	<div class="float-end mx-5">
		<button
			nbButton
			outline
			class="mt-5 me-3"
			[ngStyle]="{width: '10rem'}"
			size="medium"
			status="primary"
			(click)="superUserForm.reset()"
			type="button"
		>
			{{ 'LOGIN.RESET_BTN' | translate }}
		</button>

		<button
			class="mt-5"
			nbButton
			nbSpinnerStatus="info"
			status="secondary"
			[ngStyle]="{width: '10rem'}"
			size="medium"
			(click)="onSaveUdd()"
			[disabled]="!superUserForm.valid"
			type="button"
		>
			<!-- [class.btn-pulse]="submitted" -->
			{{ 'LOGIN.PERSONIFY_BTN' | translate }}
		</button>
	</div>
	<!-- </form> -->
</ng-template>
